import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';

const endpoint = `${apiUrl}addTeamRepo/`;

export const addTeamRepo = async (teamUUID: string, repoName: string) => {
  try {
    const response = await postWithAuth(endpoint, {
      RepoName: repoName,
      TeamUUID: teamUUID,
    });

    if (response.ok) {
      return await response.json();
    } else {
      throw new Error('Failed to add team repo');
    }
  } catch (error) {
    console.error('Error adding team repo:', error);
    throw error;
  }
};
